export const ENTRY_FORM_LOGS = `
query entryFormLogs(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: EntryFormLogOrderInput,
  $filter: FilterEntryFormLogInput,
  $searchText: String
){
  entryFormLogs(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on EntryFormLog{
      id
      entry_form_id
      log_action_id
      log_action{
        id
        name
        translation_key
      }
      old_status_id
      old_status{
        id
        name
      }
      new_status_id
      new_status{
        id
        name
      }
      user{
        email
        contact {
          firstname
          lastname
        }
      }
      description
      its
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const ENTRY_FORM_LOG_COUNT = `
query entryFormLogCount(
  $tenant_id: Int!,
  $filter: FilterEntryFormLogInput,
  $searchText: String
){
  entryFormLogCount(
    tenant_id:$tenant_id,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on Count{
      count
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
